module.exports = __webpack_public_path__ + "static/media/9.a7739b9a.jpg";